import { FormikProps } from 'formik';
import React, { FunctionComponent } from 'react';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import { INewContactInfo } from '../../../../common/models/contact/INewContactInfo';
import Icon from '../../../../components/Icon';
import Input from '../../../../components/Input';
import LinkButton from '../../../../components/LinkButton';
import RegularButton from '../../../../components/RegularButton';
import { initialFormValues } from './utils';
import styles from './styles.module.scss';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';

interface IProps extends FormikProps<INewContactInfo> {
  isSearching?: boolean;
  isFormSubmitting: boolean;
  buttonText: IFormattedMessage;
  onBlur?: (isEmail?: true) => void;
  onFocus?: IBindingCallback1<keyof INewContactInfo>;
  onSubmit: IBindingAction;
}

const AddContactForm: FunctionComponent<IProps> = ({
  values: { firstName, lastName, email, phoneNumber },
  errors,
  isValid,
  buttonText,
  isSearching = true,
  isFormSubmitting,
  onSubmit,
  setValues,
  setFieldValue,
  onBlur = () => null,
  onFocus = () => null
}) => {
  const getError = (field: keyof INewContactInfo) => (isFormSubmitting && errors[field] ? errors[field] : undefined);

  const onClearAll = () => setValues(initialFormValues);

  return (
    <form className={styles.addContactForm}>
      <Input
        type="email"
        label={{ id: 'email', defaultMessage: 'Email' }}
        onBlur={() => onBlur(true)}
        onFocus={() => onFocus('email')}
        errorIntl={getError('email')}
        onChange={val => setFieldValue('email', val)}
        variant="underlined"
        value={email}
        disableAutocomplete
        className={styles.addContactFormInput}
      />
      <Input
        type="text"
        label={{ id: 'firstName', defaultMessage: 'First Name' }}
        onBlur={() => onBlur()}
        onFocus={() => onFocus('firstName')}
        errorIntl={getError('firstName')}
        onChange={val => setFieldValue('firstName', val)}
        variant="underlined"
        value={firstName}
        disableAutocomplete
        className={styles.addContactFormInput}
      />
      <Input
        type="text"
        label={{ id: 'lastName', defaultMessage: 'Last Name' }}
        onBlur={() => onBlur()}
        onFocus={() => onFocus('lastName')}
        errorIntl={getError('lastName')}
        onChange={val => setFieldValue('lastName', val)}
        variant="underlined"
        value={lastName}
        disableAutocomplete
        className={styles.addContactFormInput}
      />
      <Input
        type="phoneNumber"
        label={{ id: 'phoneNumber', defaultMessage: 'Phone number' }}
        onBlur={() => onBlur()}
        onFocus={() => onFocus('phoneNumber')}
        errorIntl={getError('phoneNumber')}
        onChange={val => setFieldValue('phoneNumber', val)}
        variant="underlined"
        value={phoneNumber}
        disableAutocomplete
        className={styles.addContactFormInput}
      />
      <div className={styles.addContactFormBttns}>
        {Boolean(isSearching) && <LinkButton textIntlId="Clear All" onClick={onClearAll} />}
        <RegularButton
          enableAction
          onClick={onSubmit}
          textIntlId={buttonText.id}
          defaultMessage={buttonText.defaultMessage}
          disabled={!isValid}
          icon={<Icon icon="plus" />}
        />
      </div>
    </form>
  );
};

export default AddContactForm;
